import React, { memo } from 'react';
import { Divider, Tab, Tabs as MaterialUITabs } from '@mui/material';
import RestrictedTab from 'components/Tabs/components/RestrictedTab';
import { TabsProps } from 'components/Tabs/types';

const Tabs: React.FC<TabsProps> = ({ tabs, activeTab, handleChange }) => {
  const a11yProps = (index: number) => {
    return {
      id: `tab-${index}`,
      'aria-controls': `tabpanel-${index}`,
    };
  };

  return (
    <>
      <MaterialUITabs
        value={activeTab}
        onChange={handleChange}
        sx={{
          '& .MuiTabs-indicator': { height: '4px' },
          '& .MuiTabs-scrollButtons.Mui-disabled': { opacity: 0.5 }, // Style for the disabled scroll buttons
          borderBottom: 1,
          borderColor: 'divider',
          width: '100%',
        }}
        variant='scrollable' // Make the tab bar scrollable
        scrollButtons='auto' // Show scroll buttons automatically when tabs overflow
      >
        {tabs.map((tab, index) => (
          <Tab
            key={index}
            disabled={typeof tab === 'string' ? false : tab.disabled}
            label={
              typeof tab === 'string' ? tab : tab.disabled ? <RestrictedTab>{tab.label}</RestrictedTab> : tab.label
            }
            disableRipple
            {...a11yProps(index)}
            sx={{
              fontSize: '16px',
              textTransform: 'capitalize',
              textAlign: 'left',
            }}
          />
        ))}
      </MaterialUITabs>
    </>
  );
};

export default memo(Tabs);
